import { useMemo } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { consentStatuses, routePaths, strCode } from "../../../consts";
import { t } from "../../../services";
import { consentUtil } from "../../../utils";

import { BreadcrumbContainer } from "../styled";
import { LinkStyled } from "../../NavLink/styled";

const ConsentDetailsBreadcrumb = ({
  slashBefore = false,
  slashAfter = false,
  onClick,
  isSameConsentData
}) => {
  const isDuplicate = useSelector((store) => store.consents.isDuplicate);
  const selectedConsent = useSelector((store) => store.consents.selectedConsent);
  const selectedConsentElement = useSelector((store) => store.consents.selectedConsentElement);
  const { appName } = useParams();

  const history = useHistory();

  const isDisable = useMemo(() => {
    return (
      !isSameConsentData &&
      (history.location.pathname.includes(routePaths.CONSENT_ELEMENT_CREATE) ||
        history.location.pathname.includes(routePaths.CONSENT_ELEMENT_EDIT))
    );
  }, []);

  const consentVersionText = useMemo(() => {
    if (selectedConsent?.status === consentStatuses.draft) {
      const maxConsentPosition = selectedConsent.items.length
        ? Math.max(...selectedConsent.items.map((item) => item.position))
        : 0;

      return t(strCode.DRAFT_CONSENT_POSITION_TITLE, {
        position: !isNaN(Number(selectedConsentElement?.position))
          ? selectedConsentElement?.position
          : maxConsentPosition + 1
      });
    }

    if (isDuplicate && selectedConsent) {
      return `${t(strCode.DUPLICATE_BTN)} ${t(strCode.CONSENT_VERSION_TITLE, {
        version: selectedConsent.version
      })}`;
    }

    if (!isDuplicate && selectedConsent) {
      return t(strCode.CONSENT_VERSION_TITLE, { version: selectedConsent.version });
    }

    const version = consentUtil.getNewConsentVersion();

    return t(strCode.NEW_CONSENT_VERSION_TITLE, { version: version });
  }, []);

  return (
    <LinkStyled
      as={isSameConsentData ? Link : "button"}
      to={`${routePaths.APPS}/${appName}${routePaths.CONSENTS_CONSENT_ELEMENTS}`}
      onClick={() => {
        if (!isSameConsentData) {
          onClick && onClick();
        }
      }}
      disabled={isDisable}>
      <BreadcrumbContainer slashBefore={slashBefore} slashAfter={slashAfter}>
        {consentVersionText}
      </BreadcrumbContainer>
    </LinkStyled>
  );
};

ConsentDetailsBreadcrumb.propTypes = {
  slashBefore: PropTypes.bool,
  slashAfter: PropTypes.bool,
  isSameConsentData: PropTypes.bool,
  onClick: PropTypes.func
};

export default ConsentDetailsBreadcrumb;
